/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Grid from "@mui/material/Grid";
import { useMemo } from "react";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import EventCalendar from "examples/Calendar";
import BusinessEventCalendar from "examples/Calendar/EventCalendar";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Calendar application components
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";
import Header from "layouts/applications/calendar/components/Header";
import NextEvents from "layouts/applications/calendar/components/NextEvents";
import ProductivityChart from "layouts/applications/calendar/components/ProductivityChart";

// Data
import calendarEventsData from "layouts/applications/calendar/data/calendarEventsData";

import BusinessPageTemplate from "./BusinessTemplate";

function BusinessCalendar() {
  return (
    <BusinessPageTemplate title="Business Calendar">
      {useMemo(
        () => (
          <BusinessEventCalendar />
        ),
        [calendarEventsData]
      )}
    </BusinessPageTemplate>
  );
}

export default BusinessCalendar;
